export const DESKTOP_NAV_SECTION_HEIGHTS_PX = {
  expandedHeaderDisplayAd: 260,
  headerDisplayAd: 90,
  mainMenu: 48,
  quoteBar: 52,
  rotatingBanner: 80,
  topBar: 32,
} as const;

export type EstimateDesktopStickyNavOffsetInput = {
  hideTopBar?: boolean;
  hideQuoteBar?: boolean;
  showRotatingBanner?: boolean;
  showHeaderDisplayAd?: boolean;
  expandedHeaderDisplayAd?: boolean;
};

/**
 * SSR-safe desktop nav height for the fixed-header placeholder.
 * Matches composed section heights so first paint does not collapse/expand.
 */
export function estimateDesktopStickyNavOffsetPx({
  expandedHeaderDisplayAd,
  hideQuoteBar,
  hideTopBar,
  showHeaderDisplayAd,
  showRotatingBanner,
}: EstimateDesktopStickyNavOffsetInput = {}): number {
  let offsetPx = DESKTOP_NAV_SECTION_HEIGHTS_PX.mainMenu;
  if (!hideTopBar) offsetPx += DESKTOP_NAV_SECTION_HEIGHTS_PX.topBar;
  if (!hideQuoteBar) offsetPx += DESKTOP_NAV_SECTION_HEIGHTS_PX.quoteBar;
  if (showRotatingBanner) {
    offsetPx += DESKTOP_NAV_SECTION_HEIGHTS_PX.rotatingBanner;
  } else if (showHeaderDisplayAd) {
    offsetPx += expandedHeaderDisplayAd
      ? DESKTOP_NAV_SECTION_HEIGHTS_PX.expandedHeaderDisplayAd
      : DESKTOP_NAV_SECTION_HEIGHTS_PX.headerDisplayAd;
  }
  return offsetPx;
}

export function shouldLoadHeaderDisplayAd(
  viewport: 'mobile' | 'desktop' | 'pending',
  showHeaderDisplayAd: boolean,
): boolean {
  return viewport !== 'pending' && showHeaderDisplayAd;
}
